import { useState } from "react";
import { LogIn } from "lucide-react";
import Button from "../ui/Button";
import Input from "../ui/Input";

export default function LoginScreen({ onSignIn }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null); setBusy(true);
    try {
      const { error } = await onSignIn(email, password);
      if (error) throw error;
    } catch (err) {
      setError(err.message || String(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-pale-gray dark:bg-[var(--bg-page)] px-4">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2.5 mb-6 justify-center">
          <div className="w-9 h-9 rounded-lg bg-brand-ink flex items-center justify-center">
            <span className="text-white font-display font-bold text-base">U</span>
          </div>
          <div>
            <div className="font-display font-semibold text-brand-ink dark:text-[var(--text-primary)] leading-tight">UniCamel</div>
            <div className="text-[10px] uppercase tracking-wider text-brand-slate leading-tight">Agency Dashboard</div>
          </div>
        </div>

        <div className="bg-white dark:bg-[var(--bg-surface)] rounded-xl border border-gray-100 dark:border-[var(--border-soft)] shadow-card p-6 space-y-4">
          <h2 className="font-display font-semibold text-lg text-brand-ink dark:text-[var(--text-primary)]">
            Sign in
          </h2>
          <form onSubmit={submit} className="space-y-3">
            <Input label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
            <Input label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
            {error && <div className="text-xs text-red-600 bg-red-50 border border-red-200 rounded p-2">{error}</div>}
            <Button type="submit" className="w-full" disabled={busy}>
              <LogIn size={14} /> {busy ? "Signing in…" : "Sign in"}
            </Button>
          </form>
          <p className="text-xs text-brand-slate text-center pt-2 border-t border-gray-100 dark:border-[var(--border-soft)]">
            Private dashboard — accounts are added by the admin only.
          </p>
        </div>
      </div>
    </div>
  );
}
